const FAQ_INFO_ELEMENTS = {
  body: 'body',
};

const FAQ_CONTENT_INFO_ELEMENTS = {
  text: 'text',
  link: 'link',
};

class FAQInfoSection {
  constructor(params) {
    this.title = params.title;
    this.items = (params.items || []).map((item) => {
      switch (item.type) {
        case FAQ_INFO_ELEMENTS.body:
          return {
            id: item.id,
            type: item.type,
            content: (item.content || []).map((contentElement) => {
              switch (contentElement.type) {
                case FAQ_CONTENT_INFO_ELEMENTS.text:
                  return {
                    id: contentElement.id,
                    type: contentElement.type,
                    content: contentElement.content,
                  };
                case FAQ_CONTENT_INFO_ELEMENTS.link:
                  return {
                    id: contentElement.id,
                    type: contentElement.type,
                    content: contentElement.content,
                    route: contentElement.route,
                  };
                default:
                  return null;
              }
            }),
          };
        default:
          return null;
      }
    });
  }
}

export { FAQInfoSection, FAQ_INFO_ELEMENTS, FAQ_CONTENT_INFO_ELEMENTS };



// WEBPACK FOOTER //
// ./src/models/FAQInfoSection.js